<template>
    <button :class="'button ' + design" v-on:click="showQuiz">{{title}}</button>
</template>

<script>
    import jQuery from 'jquery';

    export default {
        name: "E4HButton",
        props: [
            'design',
            'title'
        ],
        methods: {
            showQuiz() {
                //console.log("SHOWQUIZ CLICK");
                //console.log(this.$parent);
                //console.log(this.$parent.quizVisible);
                jQuery('body').addClass('noscroll');

                if(window.gtag) {
                    //window.ga('send', 'event', 'boxselector', 'start');
                    window.gtag('event', 'start', {event_category: "boxselector"});
                }

                this.$parent.quizVisible = true;
                //console.log(this.$parent.quizVisible);
            },
        },
    }
</script>

<style scoped>

</style>